import React, { useContext } from 'react';
import ThemeContext from 'layout/src/components/SecondaryNavigation/_themeContext';
import IconComponent from 'ui/src/components/Icon';
import twMerge from 'utilities/src/twMerge';

interface Props {
  onClick: () => void;
}

export default function SearchButton({ onClick }: Props) {
  const { theme } = useContext(ThemeContext);
  return (
    <button
      type="button"
      className={twMerge('mdL:flex mdL:items-center mdL:gap-4 p-1.5', {
        'text-site-neutrals-400': theme !== 'dark',
        'text-site-neutrals-0': theme === 'dark',
      })}
      onClick={onClick}
    >
      <span className="mdL:block site-paragraph-m hidden">Search</span>
      <IconComponent iconName="Search" className="bg-current" />
    </button>
  );
}
